module.exports = __webpack_public_path__ + "static/media/googleIcon.733e786e.svg";